export default __webpack_public_path__ + "static/media/spotify.d0fceab7.png";